export const currentStep = state => state.currentStep;
export const quote = state => state.quote;
export const products = state => state.products;
export const amount = state => state.amount;
export const errors = state => state.errors;
export const cpError = state => state.cpError;
export const loading = state => state.loading;
export const saved = state => state.saved;
export const makeQuote = state => state.makeQuote;